export default __webpack_public_path__ + "static/media/balma.d5b976f6.svg";